'use client'

import * as React from 'react'
import * as SelectPrimitive from 'primitives/select'
import { CheckIcon, ChevronDownIcon } from 'primitives/icons'
import { tw } from 'utils/classnames'

export function Select({
  value,
  items,
  onValueChange,
  classNameTrigger,
  classNameContent,
  classNameItem,
  classNameIcon,
  position = 'item-aligned',
  wrapLabels = false,
}: {
  value: string
  items: { value: string; label: string }[]
  onValueChange: (value: string) => void
  classNameTrigger?: string
  classNameContent?: string
  classNameItem?: string
  classNameIcon?: string
  position?: 'item-aligned' | 'popper'
  wrapLabels?: boolean
}) {
  return (
    <SelectPrimitive.Root value={value} onValueChange={onValueChange}>
      <SelectPrimitive.Trigger
        className={tw(
          'bg-service-white text-13 flex h-[40px] min-w-[140px] items-center justify-between gap-3 rounded border border-[#e0e2ea] p-2 pl-4 text-[#9093b2] outline-none',
          classNameTrigger,
        )}
      >
        <span className="truncate">
          <SelectPrimitive.Value aria-label={items.find(item => item.value === value)?.label}>
            {/**
             * We need this for SSR to work with the SelectPrimitive;
             * https://github.com/radix-ui/primitives/issues/1642#issuecomment-1237905560
             */}
            {items.find(item => item.value === value)?.label}
          </SelectPrimitive.Value>
        </span>
        <SelectPrimitive.Icon className="">
          <ChevronDownIcon
            className={tw(
              "transition-transform data-[state='open']/trigger:rotate-180",
              classNameIcon,
            )}
          />
        </SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content
          className={tw(
            'bg-service-white text-13 rounded-2 flex flex-col gap-1 text-[#9093b2]',
            classNameContent,
          )}
          position={position}
        >
          <SelectPrimitive.Viewport className="p-[5px]">
            {items.map(item => (
              <SelectPrimitive.Item
                className={tw(
                  'relative flex h-[25px] cursor-pointer select-none items-center rounded pl-[25px] pr-[35px] leading-none data-[highlighted]:bg-[#e0e2ea] data-[highlighted]:outline-none',
                  classNameItem,
                )}
                key={`sorting_option_${item.value}`}
                value={item.value}
              >
                <SelectPrimitive.ItemText>
                  {wrapLabels ? <span>{item.label}</span> : item.label}
                </SelectPrimitive.ItemText>
                <SelectPrimitive.ItemIndicator className="absolute left-0 inline-flex w-[25px] items-center justify-center">
                  <CheckIcon />
                </SelectPrimitive.ItemIndicator>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  )
}
